var take = require('../take');

module.exports = function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_dropLast.js
// module id = ./node_modules/ramda/src/internal/_dropLast.js
// module chunks = 54 55 56